import { useMemo, createElement } from "react";
import PropTypes from "prop-types";
import { ThemeProvider as ThemeProvider$1 } from "styled-components";
import { merge } from "lodash/fp";
import { defaultTheme } from "./theme-provider.config.es.js";
const propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.object
  // eslint-disable-line react/forbid-prop-types
};
const defaultProps = {
  theme: void 0
};
const ThemeProvider = ({ children, theme }) => {
  const mergedTheme = useMemo(() => merge(defaultTheme, theme), [theme]);
  return createElement(ThemeProvider$1, { theme: mergedTheme }, children);
};
ThemeProvider.propTypes = propTypes;
ThemeProvider.defaultProps = defaultProps;
export {
  ThemeProvider
};
